import * as Sentry from '@sentry/react'
import { ErrorEvent, EventHint } from '@sentry/react'
import { AxiosError, HttpStatusCode } from 'axios'
import { useEffect } from 'react'

import { UserInfo } from '@/api/models/auth/lib/auth.types'

type Props = {
  userLoading: boolean
  user?: UserInfo
}

export const useSetSentryUser = ({ userLoading, user }: Props) => {
  useEffect(() => {
    if (!userLoading && user) {
      Sentry.setUser({
        id: user?.guid
      })
    }
  }, [userLoading, user])
}

export const handleAxiosErrorEvent = (event: ErrorEvent, hint: EventHint) => {
  const error = hint.originalException as AxiosError

  if (error?.isAxiosError && error.response) {
    event.extra = {
      ...event.extra,
      axios: {
        url: error.config?.url,
        status: error.response.status
      }
    }
  }
  if (event.exception?.values?.[0]?.type === 'AxiosError') {
    const statusCode =
      String(event?.tags?.status_code) || String(HttpStatusCode.NotFound)
    const page = event.transaction || ''
    event.fingerprint = [
      '{{ default }}',
      `status-${statusCode}`,
      `page-${page}`
    ]
  }

  return event
}
